import {
  Alert,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Snackbar,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { isArray, isEmpty, isUndefined } from 'lodash'
import { AccountBalance, AccountBalanceWallet, ArrowForward, CreditCard, KeyboardArrowRight, ListAlt, Payment } from '@mui/icons-material'
import CustomCard from '../CustomCard'
import { browserName } from 'react-device-detect'
import { getApiDataProgressPayment } from '../APIHelper'
import CryptoJS from 'crypto-js'
import { useTheme } from '@emotion/react'
import useStyles from './style'
import ConfirmDialog from '../ConfirmDialog'
import { checkNull } from '../../Helpers'

/**
 * CardDetails React Component.
 *
 * @component
 * @param {Object} props - React component props.
 * @param {Function} props.onPaymentDone - Callback function invoked when payment is completed.
 * @param {Object} props.paymentData - Data related to the payment.
 * @param {Object} props.paymentMethod - Payment method information.
 * @param {string} props.liveUrl - URL for live environment.
 * @param {Function} props.setPaySuccess - Function to set the payment success state.
 * @param {number} props.activeIndex - Active index indicating the current step or section.
 * @param {Object} props.chargeData - Data related to the charge or payment process.
 * @param {boolean} props.noCharge - Flag indicating whether there is no charge.
 * @param {Function} props.changeBtnText - Function to change the text of a button.
 * @param {string} props.linearColorsName - Name of linear gradient colors for buttons.
 * @param {boolean} props.isGradientButton - Flag indicating whether buttons have a gradient.
 * @param {string} props.paymentSelectedType - Type of selected payment method.
 * @returns {JSX.Element} CardDetails React component.
 */
const CardDetails = (props) => {
  const {
    onPaymentDone,
    paymentData,
    paymentMethod,
    liveUrl,
    setPaySuccess,
    activeIndex,
    chargeData,
    noCharge,
    changeBtnText,
    linearColorsName,
    isGradientButton,
    paymentSelectedType,
    setPaymentSelectedType,
    paymentMethodTabs,
    productDetails,
    primaryColor,
    currency_symbol,
    gatewayName,
    paymentRegionId,
    pl_code,
    merchantName,
    merchantLogo,
    setHasPopup,
    modalMode,
    loaderColor,
  } = props

  const Ref = useRef(null)
  const cardPayRef = useRef(null)
  const bankPopupRef = useRef(null)
  const [cardPayDisabled, setCardPayDisabled] = useState(true)
  const [usingSavedCard, setUsingSavedCardRaw] = useState(false)
  const [saveCard, setSaveCard] = useState(false)

  const setUsingSavedCard = (val) => {
    setUsingSavedCardRaw(val)
    if (val) setSaveCard(false)
  }
  const styles = useStyles()
  const theme = useTheme()
  const sm = useMediaQuery(theme.breakpoints.down('sm'))
  const lg = useMediaQuery(theme.breakpoints.down('lg'))
  const [contentLoade, setContentLoader] = useState(false)
  const [isSelected, setIsSelected] = useState('')

  const [paymentType, setPaymentType] = useState([])
  const [paymentSearchType, setPaymentSearchType] = useState([])
  const [tabSelected, setTabSelected] = useState({})

  const [isBankSelect, setIsBankSelect] = useState({})

  const currentDomain = window.location
  const [clientSecret, setClientSecret] = useState('')

  const [search, setSearch] = useState('')
  const [confirmDialog, setConfirmDialog] = useState(false)

  const [isHovered, setIsHovered] = useState({})
  const [open, setOpen] = useState(false)
  const orderDetailsData = props?.order_details || paymentData?.order_details

  const isRecurring =
    paymentData?.payThroughRecurrence ||
    paymentData?.payThroughEMI ||
    paymentData?.updateSubscription

  const isUpdate = paymentData?.updateSubscription && !paymentData?.payThroughRecurrence
  const showAmountInBtn = !isUpdate

  const paymentGatwayFee = (
    tabSelected?.charge_object?.charges_obj?.final_amount -
    chargeData?.withChargeAmount || 0
  )?.toFixed(2)

  const finalAmount = noCharge
    ? paymentData?.amount || 0
    : // : chargeData?.isPaymentGateWay
    // ? cardBrandSelect?.charge_object?.charges_obj?.final_amount ||0
    chargeData?.withChargeAmount

  const handleMouseEnter = (index) => {
    setIsHovered({ index })
  }

  const handleMouseLeave = () => {
    setIsHovered({})
  }

  // Auto-select the first available payment method on initial mount only
  const initialSelected = useRef(false)
  useEffect(() => {
    if (initialSelected.current) return
    const findIn = paymentMethod?.findIndex(
      (v) =>
        v?.type === paymentSelectedType &&
        v['payment_method.payment_method'] !== 'Google Pay' &&
        v['payment_method.payment_method'] !== 'Apple Pay' &&
        !isEmpty(v?.charge_object)
    )
    if (findIn !== -1) {
      initialSelected.current = true
      const method = paymentMethod[findIn]
      setTabSelected(method)
      setIsSelected(findIn)
    }
  }, [paymentMethod])

  useEffect(() => {
    setIsBankSelect({})
  }, [isSelected])

  function filterVal(val) {
    if (isEmpty(val)) {
      setPaymentSearchType(paymentType)
    } else {
      const newData = paymentType?.filter((item) => {
        return (
          item['payment_sub_method.type']
            ?.toLowerCase()
            .indexOf(val?.toLowerCase()) > -1
        )
      })
      setPaymentSearchType(newData)
    }
    setSearch(val)
  }

  /**
   * Fetch payment sub-options for non-card methods (bank, wallet).
   */
  const getPaymentOption = (method, index) => {
    setContentLoader(true)
    try {
      fetch(
        `${liveUrl}payment-options/${paymentData.country_code}?method=${method ? method : ''
        }&mode=${chargeData?.mode}&amount=${noCharge ? paymentData?.amount : chargeData?.withChargeAmount
        }&currency=${paymentData?.currency}&reccurance=${isRecurring}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${chargeData?.auth_token}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          if (response?.status) {
            setPaymentType(response?.data)
            setPaymentSearchType(response?.data)
            setTabSelected(response?.data[0])
            setContentLoader(false)
          } else {
            setContentLoader(false)
          }
        })
        .catch((err) => {
          console.log(err.message)
          setContentLoader(false)
        })
    } catch (error) {
      setContentLoader(false)
      console.log('error:', error)
    }
  }
  async function SaveOrder(subData, type) {
    setPaySuccess('loading')
    try {
      const data = {
        name: paymentData?.name,
        amount: chargeData?.withChargeAmount,
        final_amount: subData?.charge_object?.charges_obj?.final_amount,
        app_token: paymentData?.app_token,
        country_id: subData?.country_id,
        currency: paymentData?.currency,
        mode: chargeData?.mode,
        payment_method_id: subData?.payment_method_id,
        payment_sub_method_id: subData?.payment_sub_method_id,
        transaction_code: paymentData?.transaction_code,
        gateway_code: subData?.charge_object?.gateway_code,
        gateway_id: subData?.gateway_id,
        email: paymentData?.email,
        payment_gateway_fee: noCharge
          ? 'inclusive'
          : chargeData?.isPaymentGateWay
            ? 'exclusive'
            : 'inclusive',
        base_amount: paymentData?.amount,
        charge_id: subData?.charge_object?.charges_obj?.id,
        platform: 'web',
        charges_json: JSON.stringify(chargeData?.mainChargeData),
        mobile: paymentData?.mobile,
        chargeAsFixedAmount: paymentData?.chargeAsFixedAmount,
        order_details: props?.order_details || paymentData?.order_details,
        address: paymentData?.address,
        to_country_code: paymentData?.toCountryCode,
        pl_code: pl_code,
      }
      const response = await getApiDataProgressPayment(
        `${liveUrl}save-order`,
        'POST',
        JSON.stringify(data),
        chargeData?.auth_token
      )
      if (response?.status == false) {
        setPaySuccess('fail', response?.message)
        setTimeout(() => {
          setPaySuccess(false)
        }, 5000)
      } else {
        setTimeout(() => {
          paymentApi(subData, response?.code)
        }, 1000)
      }
    } catch (error) {
      console.log('error:', error)
    }
  }

  /**
   * Process payment API with the provided data and order code.
   *
   * @param {Object} data - The payment data for the API request.
   * @param {string} code - The order code associated with the payment.
   * @throws {Error} Throws an error if the payment API request fails.
   * @returns {Promise<void>} A promise that resolves after processing the payment.
   */
  async function paymentApi(data, code) {
    let final_data = {
      amount: {
        amount: paymentData?.amount,
        final_amount: data?.charge_object?.charges_obj?.final_amount,
      },
    }

    // Encrypt
    let ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(final_data),
      '470cb677d807b1e0017c50b'
    ).toString()

    const Ddata = {
      data: ciphertext,
      order_code: code,
      is_new: 1,
      redirect_url: currentDomain?.origin,
    }

    try {
      const response = await getApiDataProgressPayment(
        `${liveUrl}custom-checkout`,
        'POST',
        JSON.stringify(Ddata),
        chargeData?.auth_token
      )
      if (isUndefined(response) || response?.status === false) {
        if (bankPopupRef.current) {
          bankPopupRef.current.close()
          bankPopupRef.current = null
        }
        setPaySuccess('fail', response?.message)
        setTimeout(() => {
          setPaySuccess(false)
        }, 5000)
      } else if (
        (response?.status === 'processing' || response?.status === true) &&
        paymentData?.currency !== 'INR'
      ) {
        if (response?.data && response?.data.redirect_url) {
          setPaySuccess('loading', '', {
            redirect_url: response?.data.redirect_url,
            code: code,
            popup: bankPopupRef.current,
          })
          bankPopupRef.current = null
        }
      } else {
        if (!isEmpty(data)) {
          setPaySuccess('url', response?.data.redirect_url)
        } else {
          setPaySuccess('success')
          onPaymentDone()
        }
      }
    } catch (error) {
      if (bankPopupRef.current) {
        bankPopupRef.current.close()
        bankPopupRef.current = null
      }
      setPaySuccess('fail')
      setTimeout(() => {
        setPaySuccess(false)
      }, 5000)
      console.log('error:', error)
    }
  }

  /**
   * Check the progress of a payment using the provided order code and transaction code.
   *
   * @param {string} code - The order code associated with the payment.
   * @throws {Error} Throws an error if there's an issue checking the payment progress.
   * @returns {Promise<void>} A promise that resolves after checking the payment progress.
   */

  /**
   * Render the first display of payment methods.
   *
   * @returns {React.ReactNode} React node representing the rendered payment methods.
   */
  const isForUpdateSub = paymentData?.updateSubscription

  const appName =
    isArray(productDetails) && productDetails?.length > 0
      ? productDetails[0]?.name
      : null

  const isRecurringPayment =
    paymentData?.payThroughRecurrence || paymentData?.payThroughEMI

  const getIntervalLabel = () => {
    if (!isRecurringPayment || !paymentData?.recurrenceObj) return ''
    const type = paymentData.recurrenceObj.intervalType?.toLowerCase() || ''
    if (type.includes('month')) return 'per month'
    if (type.includes('year') || type.includes('annual')) return 'per year'
    if (type.includes('week')) return 'per week'
    if (type.includes('day') || type.includes('daily')) return 'per day'
    return ''
  }

  const getBilledLabel = () => {
    if (!isRecurringPayment || !paymentData?.recurrenceObj) return ''
    const type = paymentData.recurrenceObj.intervalType?.toLowerCase() || ''
    if (type.includes('month')) return 'billed monthly'
    if (type.includes('year') || type.includes('annual')) return 'billed annually'
    if (type.includes('week')) return 'billed weekly'
    if (type.includes('day') || type.includes('daily')) return 'billed daily'
    return ''
  }

  const hasAddress = paymentData?.address
  const formatAddress = (address) => {
    if (!address) return ''
    if (typeof address === 'string') return address
    const parts = [
      address?.line1 || address?.street,
      address?.line2,
      address?.city,
      address?.state,
      address?.postal_code || address?.zip,
      address?.country,
    ].filter(Boolean)
    return parts.join(', ')
  }

  const { isCard, isBank, isOther } = paymentMethodTabs || {}

  const formatAmt = (amt) => {
    if (checkNull(amt?.toString())) return '0'
    const num = Number(amt)
    return num.toLocaleString('en-IN', {
      minimumFractionDigits: Number.isInteger(num) ? 0 : 2,
      maximumFractionDigits: 2,
    })
  }

  return (
    <Grid container style={{ flexGrow: 1 }} alignItems='stretch'>
      {/* LEFT PANEL - Summary (only shown for payment links, not client integrations, not modal mode) */}
      {!isForUpdateSub && pl_code && !modalMode && (
        <Grid item xs={12} lg={6} style={{ background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: sm ? '24px 16px' : '40px 32px' }}>
          <div style={{ width: '100%', maxWidth: 440 }}>
            {/* Merchant row */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
              {merchantLogo ? (
                <img
                  src={merchantLogo}
                  alt="logo"
                  style={{ width: 44, height: 44, borderRadius: 10, objectFit: 'contain', border: '1px solid #eee' }}
                />
              ) : (
                <div style={{ width: 44, height: 44, borderRadius: 10, background: '#f0f4f8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <ListAlt style={{ fontSize: 24, color: primaryColor || '#0068EF' }} />
                </div>
              )}
              <div>
                {isRecurringPayment && (
                  <Typography style={{ fontSize: 11, color: '#8a96a8', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    Subscribing to
                  </Typography>
                )}
                <Typography style={{ fontSize: 17, fontWeight: 600, color: '#1a1a2e' }}>
                  {merchantName || appName || paymentData?.name || 'Payment'}
                </Typography>
              </div>
            </div>

            {/* Large amount */}
            <div>
              <Typography style={{ fontSize: sm ? 32 : 36, fontWeight: 700, color: '#1a1a2e', letterSpacing: '-1px', lineHeight: 1.1 }}>
                {currency_symbol} {formatAmt(finalAmount)}
              </Typography>
              {isRecurringPayment && (
                <Typography style={{ fontSize: 13, color: '#8a96a8', marginTop: 4 }}>
                  {getIntervalLabel()} · {getBilledLabel()}
                </Typography>
              )}
            </div>

            {/* ─── User Details Section ─── */}
            {(paymentData?.name || paymentData?.mobile || paymentData?.email) && (
              <div style={{ marginTop: 24, background: '#fff', borderRadius: 12, border: '1px solid #eef1f5', overflow: 'hidden' }}>
                <Typography style={{ fontSize: 12, fontWeight: 600, color: '#8a96a8', textTransform: 'uppercase', letterSpacing: 0.5, padding: '14px 20px 8px' }}>
                  User Details
                </Typography>
                {paymentData?.name && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', borderBottom: '1px solid #eef1f5' }}>
                    <Typography style={{ fontSize: 13, color: '#8a96a8' }}>Name</Typography>
                    <Typography style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>{paymentData.name}</Typography>
                  </div>
                )}
                {paymentData?.mobile && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', borderBottom: '1px solid #eef1f5' }}>
                    <Typography style={{ fontSize: 13, color: '#8a96a8' }}>Contact</Typography>
                    <Typography style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>{paymentData.mobile}</Typography>
                  </div>
                )}
                {paymentData?.email && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', borderBottom: hasAddress ? '1px solid #eef1f5' : 'none' }}>
                    <Typography style={{ fontSize: 13, color: '#8a96a8' }}>Email</Typography>
                    <Typography style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>{paymentData.email}</Typography>
                  </div>
                )}
                {hasAddress && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '10px 20px' }}>
                    <Typography style={{ fontSize: 13, color: '#8a96a8' }}>Billing Address</Typography>
                    <Typography style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e', textAlign: 'right', maxWidth: '60%', lineHeight: 1.5 }}>
                      {formatAddress(paymentData.address)}
                    </Typography>
                  </div>
                )}
              </div>
            )}

            {/* ─── Price Breakdown Section ─── */}
            {orderDetailsData && isArray(orderDetailsData?.order_data) && orderDetailsData.order_data.length > 0 && (
              <div style={{ marginTop: 24, background: '#fff', borderRadius: 12, border: '1px solid #eef1f5', overflow: 'hidden' }}>
                <Typography style={{ fontSize: 12, fontWeight: 600, color: '#8a96a8', textTransform: 'uppercase', letterSpacing: 0.5, padding: '14px 20px 8px' }}>
                  Price Breakdown
                </Typography>

                {orderDetailsData.order_data.map((item, index) => {
                  const itemTotal = (Number(item?.price) || 0) * (Number(item?.quantity) || 1)
                  return (
                    <div
                      key={index}
                      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', borderBottom: '1px solid #eef1f5' }}
                    >
                      <div style={{ flex: 1 }}>
                        <Typography style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>
                          {item?.item}
                        </Typography>
                        {(item?.quantity > 1) && (
                          <Typography style={{ fontSize: 11, color: '#8a96a8', marginTop: 2 }}>
                            {item?.quantity} × {currency_symbol}{Number(item?.price || 0).toFixed(2)}
                          </Typography>
                        )}
                      </div>
                      <Typography style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>
                        {currency_symbol}{itemTotal.toFixed(2)}
                      </Typography>
                    </div>
                  )
                })}

                {/* Subtotal */}
                {orderDetailsData.order_data.length > 1 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 20px', borderBottom: '1px solid #eef1f5' }}>
                    <Typography style={{ fontSize: 13, color: '#8a96a8' }}>Subtotal</Typography>
                    <Typography style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>
                      {currency_symbol}
                      {orderDetailsData.order_data
                        .reduce((sum, i) => sum + (Number(i?.price) || 0) * (Number(i?.quantity) || 1), 0)
                        .toFixed(2)}
                    </Typography>
                  </div>
                )}

                {/* Platform Fee */}
                {orderDetailsData?.platform_fee && Number(orderDetailsData.platform_fee.value) > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 20px', borderBottom: '1px solid #eef1f5' }}>
                    <Typography style={{ fontSize: 13, color: '#8a96a8' }}>
                      {orderDetailsData.platform_fee.name || 'Platform Fee'}
                      {orderDetailsData.platform_fee.chargeAsPercentage && ` (${orderDetailsData.platform_fee.value}%)`}
                    </Typography>
                    <Typography style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>
                      {orderDetailsData.platform_fee.chargeAsPercentage
                        ? `${currency_symbol}${(
                            (Number(orderDetailsData.platform_fee.value) / 100) *
                            orderDetailsData.order_data.reduce((sum, i) => sum + (Number(i?.price) || 0) * (Number(i?.quantity) || 1), 0)
                          ).toFixed(2)}`
                        : `${currency_symbol}${Number(orderDetailsData.platform_fee.value).toFixed(2)}`}
                    </Typography>
                  </div>
                )}

                {/* Taxes */}
                {isArray(orderDetailsData?.taxes) &&
                  orderDetailsData.taxes
                    .filter((t) => Number(t?.amount) > 0)
                    .map((tax, idx, arr) => (
                      <div
                        key={idx}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          padding: '10px 20px',
                          borderBottom: (idx < arr.length - 1 || (orderDetailsData?.roundoff && Number(orderDetailsData.roundoff) !== 0)) ? '1px solid #eef1f5' : 'none',
                        }}
                      >
                        <Typography style={{ fontSize: 13, color: '#8a96a8' }}>
                          {tax?.description || 'Tax'}
                        </Typography>
                        <Typography style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>
                          {currency_symbol}{Number(tax?.amount).toFixed(2)}
                        </Typography>
                      </div>
                    ))}

                {/* Round Off */}
                {orderDetailsData?.roundoff && Number(orderDetailsData.roundoff) !== 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 20px' }}>
                    <Typography style={{ fontSize: 13, color: '#8a96a8' }}>Round Off</Typography>
                    <Typography style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>
                      {orderDetailsData.roundOffSign === '-' ? '-' : '+'}{currency_symbol}{Number(orderDetailsData.roundoff).toFixed(2)}
                    </Typography>
                  </div>
                )}
              </div>
            )}

            {/* ─── Total Amount Row ─── */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20, padding: '12px 0' }}>
              <Typography style={{ fontSize: 15, fontWeight: 600, color: '#1a1a2e' }}>
                Total
              </Typography>
              <Typography style={{ fontSize: 20, fontWeight: 700, color: primaryColor || '#0068EF' }}>
                {currency_symbol}{formatAmt(finalAmount)}
              </Typography>
            </div>

          </div>
        </Grid>
      )}

      {/* RIGHT PANEL - Payment method accordion */}
      <Grid
        item
        xs={12}
        lg={(isForUpdateSub || !pl_code || modalMode) ? 12 : 6}
        style={{
          padding: modalMode ? (sm ? '12px 16px' : '12px 24px') : (sm ? '20px 16px' : '32px 28px'),
          display: 'flex',
          flexDirection: 'column',
          ...( (!pl_code || isForUpdateSub) && !modalMode ? { alignItems: 'center' } : {}),
        }}
      >
        {/* Wrapper to constrain width in non-modal centered layouts */}
        <div style={{ width: '100%', ...(!modalMode ? { maxWidth: 480 } : {}) }}>
        {!modalMode && (
          <Typography style={{ fontSize: 16, fontWeight: 600, color: '#1a1a2e', marginBottom: 16 }}>
            Payment method
          </Typography>
        )}

        {/* Method list */}
        <div style={{ width: '100%', border: '1px solid #e0e6ed', borderRadius: 12, overflow: 'hidden' }}>
          {/* Card methods — each card type as its own row */}
          {isArray(paymentMethod) && paymentMethod?.map((item, index) => {
            const methodName = item['payment_method.payment_method']
            if (methodName === 'Google Pay' || methodName === 'Apple Pay') return null
            if (isEmpty(item?.charge_object)) return null
            if (item?.type !== 'card') return null

            const isActive = isSelected === index

            return (
              <div key={item?.id || index}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    padding: '14px 16px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #eef1f5',
                    background: isActive ? '#f0f6ff' : 'transparent',
                    transition: 'background 0.15s',
                  }}
                  onClick={() => {
                    if (isActive) return
                    setIsSelected(index)
                    setPaymentSelectedType('card')
                    setIsBankSelect({})
                    setSearch('')
                    // Use payment method directly — no sub-method API call needed for cards
                    setTabSelected(item)
                  }}
                >
                  <div style={{ width: 16, height: 16, borderRadius: '50%', border: `2px solid ${isActive ? (primaryColor || '#0068EF') : '#c0ccd8'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    {isActive && (
                      <div style={{ width: 8, height: 8, borderRadius: '50%', background: primaryColor || '#0068EF' }} />
                    )}
                  </div>
                  {item['payment_method.logo'] ? (
                    <img
                      src={item['payment_method.logo']}
                      style={{ width: 32, height: 32, objectFit: 'contain', borderRadius: 4 }}
                      alt={methodName}
                    />
                  ) : (
                    <CreditCard style={{ fontSize: 24, color: '#8a96a8' }} />
                  )}
                  <Typography style={{ fontSize: 14, fontWeight: 500, color: '#1a1a2e' }}>
                    {methodName}
                  </Typography>
                </div>

                {/* Card expanded form */}
                {isActive && (
                  <div style={{ borderBottom: '1px solid #eef1f5' }}>
                    {contentLoade ? (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 150 }}>
                        <CircularProgress size={24} style={{ color: loaderColor || primaryColor }} />
                      </div>
                    ) : (
                      <div style={{ padding: '12px 16px' }}>
                        <CustomCard
                          {...props}
                          accordionMode
                          onPayRef={cardPayRef}
                          onDisabledChange={setCardPayDisabled}
                          onSavedCardChange={setUsingSavedCard}
                          externalSaveCard={saveCard}
                          gatewayName={gatewayName}
                          paymentType={paymentType}
                          paymentData={paymentData}
                          currency_symbol={currency_symbol}
                          cardBrandSelect={tabSelected}
                          chargeData={chargeData}
                          noCharge={noCharge}
                          primaryColor={primaryColor}
                          setPaySuccess={setPaySuccess}
                          onPaymentDone={onPaymentDone}
                          changeBtnText={changeBtnText}
                          paymentRegionId={paymentRegionId}
                          type={methodName}
                          setTabValue={(value) => {
                            setTabSelected(value)
                          }}
                          liveUrl={liveUrl}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            )
          })}

          {/* Bank — single grouped row */}
          {!isEmpty(isBank) && (
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: '14px 16px',
                  cursor: 'pointer',
                  borderBottom: !isEmpty(isOther) ? '1px solid #eef1f5' : 'none',
                  background: paymentSelectedType === 'bank' ? '#f0f6ff' : 'transparent',
                  transition: 'background 0.15s',
                }}
                onClick={() => {
                  if (paymentSelectedType === 'bank') return
                  setPaymentSelectedType('bank')
                  setIsBankSelect({})
                  setSearch('')
                  const bankIdx = paymentMethod?.findIndex(
                    (v) => v?.type === 'bank' &&
                      v['payment_method.payment_method'] !== 'Google Pay' &&
                      v['payment_method.payment_method'] !== 'Apple Pay'
                  )
                  if (bankIdx !== -1) {
                    setIsSelected(bankIdx)
                    const bm = paymentMethod[bankIdx]['payment_method.payment_method']
                    if (bm === 'UPI' || (bm === 'ACH' && isEmpty(paymentMethod[bankIdx]?.ach_fields))) {
                      setTabSelected(paymentMethod[bankIdx])
                    } else {
                      getPaymentOption(paymentMethod[bankIdx]?.payment_method_id, bankIdx)
                    }
                  }
                }}
              >
                <div style={{ width: 16, height: 16, borderRadius: '50%', border: `2px solid ${paymentSelectedType === 'bank' ? (primaryColor || '#0068EF') : '#c0ccd8'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {paymentSelectedType === 'bank' && (
                    <div style={{ width: 8, height: 8, borderRadius: '50%', background: primaryColor || '#0068EF' }} />
                  )}
                </div>
                <AccountBalance style={{ fontSize: 24, color: '#8a96a8' }} />
                <Typography style={{ fontSize: 14, fontWeight: 500, color: '#1a1a2e' }}>Bank</Typography>
              </div>
              {paymentSelectedType === 'bank' && (
                <div style={{ padding: '12px 16px' }}>
                  {contentLoade ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100 }}>
                      <CircularProgress size={24} style={{ color: loaderColor || primaryColor }} />
                    </div>
                  ) : isSelected && !isEmpty(isBankSelect) ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, padding: '8px 0' }}>
                      <Typography style={{ fontSize: 15, fontWeight: 500, color: '#1a1a2e' }}>
                        {isBankSelect['payment_sub_method.type']}
                      </Typography>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '14px 24px',
                          borderRadius: 12,
                          color: '#fff',
                          fontWeight: 600,
                          fontSize: 15,
                          cursor: 'pointer',
                          width: '100%',
                          boxSizing: 'border-box',
                          background: primaryColor || '#0068EF',
                          justifyContent: showAmountInBtn ? 'space-between' : 'center',
                        }}
                        onClick={() => setConfirmDialog(true)}
                      >
                        <span>{changeBtnText}</span>
                        {showAmountInBtn && (
                          <span style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 500 }}>
                            {currency_symbol} {formatAmt(finalAmount)}
                            <ArrowForward style={{ fontSize: 18 }} />
                          </span>
                        )}
                      </div>
                      <Typography
                        style={{ fontSize: 13, fontWeight: 500, cursor: 'pointer', color: primaryColor }}
                        onClick={() => setIsBankSelect({})}
                      >
                        Select another bank
                      </Typography>
                    </div>
                  ) : isSelected && (paymentMethod[isSelected]?.['payment_method.payment_method'] === 'Net Banking' ||
                    paymentMethod[isSelected]?.['payment_method.payment_method'] === 'Wallet') ? (
                    <>
                      <TextField
                        fullWidth size='small' variant='outlined'
                        className={styles.input}
                        placeholder='Search Bank Name'
                        value={search}
                        onChange={(e) => filterVal(e.target.value)}
                        style={{ marginBottom: 8 }}
                      />
                      <div style={{ maxHeight: 240, overflowY: 'auto' }}>
                        {isArray(paymentSearchType) && !isEmpty(paymentSearchType) ? (
                          paymentSearchType?.map((subItem, subIndex) => (
                            <div
                              key={subIndex}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                padding: '10px 12px',
                                cursor: 'pointer',
                                borderRadius: 8,
                                background: !isEmpty(isHovered) && isHovered.index === subIndex ? '#f0f6ff' : 'transparent',
                                transition: 'background 0.15s',
                              }}
                              onMouseEnter={() => handleMouseEnter(subIndex)}
                              onMouseLeave={handleMouseLeave}
                              onClick={() => { setIsBankSelect(subItem); setTabSelected(subItem) }}
                            >
                              <img src={subItem['payment_sub_method.logo']} style={{ width: 28, height: 28, objectFit: 'contain', borderRadius: 4 }} alt='' />
                              <Typography style={{ flex: 1, fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>{subItem['payment_sub_method.type']}</Typography>
                              <KeyboardArrowRight style={{ fontSize: 20, color: '#b0bac8' }} />
                            </div>
                          ))
                        ) : (
                          <Typography style={{ fontSize: 13, color: '#8a96a8', textAlign: 'center', padding: '16px 0' }}>No banks found</Typography>
                        )}
                      </div>
                    </>
                  ) : (
                    <div style={{ background: '#f8fafc', borderRadius: 10, padding: '14px 16px', border: '1px solid #eef1f5' }}>
                      <Typography style={{ fontSize: 13, color: '#5a6a7e', lineHeight: 1.6 }}>
                        Bank transfers may take <strong>up to 5 business days</strong> to complete. A verification code will be sent to your registered account — you'll need to enter it to finalise the transaction. Credit cards and other methods are processed instantly.
                      </Typography>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Wallet — single grouped row */}
          {!isEmpty(isOther) && (
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: '14px 16px',
                  cursor: 'pointer',
                  background: paymentSelectedType === 'digital wallet' ? '#f0f6ff' : 'transparent',
                  transition: 'background 0.15s',
                }}
                onClick={() => {
                  if (paymentSelectedType === 'digital wallet') return
                  setPaymentSelectedType('digital wallet')
                  setIsBankSelect({})
                  setSearch('')
                  const walletIdx = paymentMethod?.findIndex(
                    (v) => v?.type === 'digital wallet' &&
                      v['payment_method.payment_method'] !== 'Google Pay' &&
                      v['payment_method.payment_method'] !== 'Apple Pay'
                  )
                  if (walletIdx !== -1) {
                    setIsSelected(walletIdx)
                    getPaymentOption(paymentMethod[walletIdx]?.payment_method_id, walletIdx)
                  }
                }}
              >
                <div style={{ width: 16, height: 16, borderRadius: '50%', border: `2px solid ${paymentSelectedType === 'digital wallet' ? (primaryColor || '#0068EF') : '#c0ccd8'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {paymentSelectedType === 'digital wallet' && (
                    <div style={{ width: 8, height: 8, borderRadius: '50%', background: primaryColor || '#0068EF' }} />
                  )}
                </div>
                <AccountBalanceWallet style={{ fontSize: 24, color: '#8a96a8' }} />
                <Typography style={{ fontSize: 14, fontWeight: 500, color: '#1a1a2e' }}>Wallet</Typography>
              </div>
              {paymentSelectedType === 'digital wallet' && (
                <div style={{ padding: '12px 16px' }}>
                  <div style={{ background: '#f8fafc', borderRadius: 10, padding: '14px 16px', border: '1px solid #eef1f5' }}>
                    <Typography style={{ fontSize: 13, color: '#5a6a7e', lineHeight: 1.6 }}>
                      You will be redirected to your wallet provider to complete the payment.
                      Click <strong>{changeBtnText}{showAmountInBtn ? ` ${currency_symbol} ${formatAmt(finalAmount)}` : ''}</strong> to proceed.
                    </Typography>
                  </div>
                </div>
              )}
            </div>
          )}

        </div>

        {/* Save box — only for card types, hidden when using a saved card */}
        {paymentSelectedType === 'card' && !usingSavedCard && (
          <div
            style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '14px 16px', marginTop: 12, border: '1px solid #e0e6ed', borderRadius: 12, background: '#fff', cursor: paymentData?.saveCard ? 'default' : 'pointer' }}
            onClick={() => { if (!paymentData?.saveCard) setSaveCard(!saveCard) }}
          >
            <input
              type='checkbox'
              checked={paymentData?.saveCard || saveCard}
              disabled={paymentData?.saveCard}
              onChange={() => {}}
              style={{ accentColor: primaryColor || '#0068EF', marginTop: 3, width: 16, height: 16, flexShrink: 0, cursor: 'inherit', pointerEvents: 'none' }}
            />
            <div>
              <Typography style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e', lineHeight: 1.4 }}>
                Save my information for faster checkout
              </Typography>
              <Typography style={{ fontSize: 12, color: '#8a96a8', marginTop: 2 }}>
                Pay securely at AautiPay and everywhere Link is accepted.
              </Typography>
            </div>
          </div>
        )}

        {/* Pay button — split layout: label left, amount + arrow right */}
        <div style={modalMode ? { position: 'sticky', bottom: 0, background: '#fff', padding: '12px 0', borderTop: '1px solid #eef1f5', zIndex: 10 } : { marginTop: 16 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '14px 24px',
            borderRadius: 12,
            color: '#fff',
            fontWeight: 600,
            fontSize: 15,
            background: primaryColor || '#0068EF',
            cursor: paymentSelectedType === 'card' && cardPayDisabled ? 'not-allowed' : 'pointer',
            opacity: paymentSelectedType === 'card' && cardPayDisabled ? 0.5 : 1,
            justifyContent: showAmountInBtn ? 'space-between' : 'center',
          }}
          onClick={() => {
            if (paymentSelectedType === 'card') {
              if (!cardPayDisabled && cardPayRef.current) {
                cardPayRef.current()
              }
            } else {
              // Open a minimal popup immediately (user-initiated to avoid popup blockers)
              // Show a loading state matching AautiPay theme until the redirect URL arrives
              const popup = window.open('about:blank', '_blank', 'width=600,height=600')
              if (popup) {
                const popupColor = primaryColor || '#0068EF'
                const popupLoaderColor = loaderColor || popupColor
                popup.document.write(
                  '<html><head><title>Redirecting - AautiPay</title>' +
                  '<style>' +
                  '@keyframes paySpinner{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}' +
                  '@keyframes payPulse{0%,100%{opacity:0.4;transform:translate(-50%,-50%) scale(0.8)}50%{opacity:1;transform:translate(-50%,-50%) scale(1.2)}}' +
                  '</style></head>' +
                  '<body style="margin:0;font-family:Arial,sans-serif;background:#f0f4f8;display:flex;flex-direction:column;min-height:100vh;">' +
                  '<div style="flex:1;display:flex;align-items:center;justify-content:center;flex-direction:column;">' +
                  // Spinner
                  '<div style="position:relative;width:72px;height:72px;margin-bottom:28px;">' +
                  '<div style="position:absolute;inset:0;border-radius:50%;border:3px solid ' + popupLoaderColor + '15;"></div>' +
                  '<div style="position:absolute;inset:0;border-radius:50%;border:3px solid transparent;border-top-color:' + popupLoaderColor + ';animation:paySpinner 1s linear infinite;"></div>' +
                  '<div style="position:absolute;inset:8px;border-radius:50%;border:3px solid transparent;border-top-color:' + popupLoaderColor + '80;animation:paySpinner 1.5s linear infinite reverse;"></div>' +
                  '<div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:10px;height:10px;border-radius:50%;background:' + popupLoaderColor + ';animation:payPulse 1.5s ease-in-out infinite;"></div>' +
                  '</div>' +
                  // Text
                  '<p style="font-weight:700;font-size:22px;color:#1a1a2e;margin:0 0 12px 0;letter-spacing:-0.3px;">Redirecting to Payment Gateway</p>' +
                  '<p style="color:#8a96a8;font-size:14px;text-align:center;margin:0;line-height:1.7;padding:0 20px;">You will be redirected to complete your payment securely.</p>' +
                  '</div>' +
                  // Footer
                  '<div style="display:flex;align-items:center;justify-content:center;gap:4px;padding:16px;">' +
                  '<svg width="12" height="12" viewBox="0 0 24 24" fill="none"><rect x="3" y="11" width="18" height="11" rx="2" stroke="#8a96a8" stroke-width="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="#8a96a8" stroke-width="2" stroke-linecap="round"/></svg>' +
                  '<span style="color:#8a96a8;font-size:11px;">Powered by </span>' +
                  '<span style="font-weight:500;font-size:11px;color:' + (popupColor || '#0068EF') + ';">AautiPay</span>' +
                  '</div>' +
                  '</body></html>'
                )
                popup.document.close()
              }
              bankPopupRef.current = popup
              if (popup && setHasPopup) setHasPopup(popup)
              // Directly proceed for bank/wallet — no confirmation
              SaveOrder(tabSelected, 'saveO')
            }
          }}
        >
          <span>{changeBtnText}</span>
          {showAmountInBtn && (
            <span style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 500 }}>
              {currency_symbol} {formatAmt(finalAmount)}
              <ArrowForward style={{ fontSize: 18 }} />
            </span>
          )}
        </div>

        {/* Auth note for subscriptions */}
        {isRecurringPayment && (
          <Typography style={{ fontSize: 11, color: '#8a96a8', textAlign: 'center', marginTop: 12, lineHeight: 1.5 }}>
            By subscribing, you authorize AautiPay to process recurring payments in {paymentData?.currency || 'INR'} as per the plan terms until you cancel.
          </Typography>
        )}
        </div>
        </div>{/* end width constraint wrapper */}

      </Grid>

      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={() => setOpen(false)}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity='error'
          sx={{ width: '100%' }}
        >
          Apple Pay is in progress!
        </Alert>
      </Snackbar>
      <ConfirmDialog
        title={`Are you sure you want to make payment with ${
          !isEmpty(tabSelected) && tabSelected['payment_method.payment_method']
            ? tabSelected['payment_method.payment_method']
            : paymentSelectedType === 'card' ? 'Card'
            : paymentSelectedType === 'bank' ? 'Bank'
            : 'this method'
          }?`}
        visible={confirmDialog}
        changeBtnText={changeBtnText}
        chargeData={chargeData}
        primaryColor={primaryColor}
        paymentData={paymentData}
        currency_symbol={currency_symbol}
        finalAmount={finalAmount}
        paymentGatwayFee={paymentGatwayFee}
        linearColorsName={linearColorsName}
        isGradientButton={isGradientButton}
        noCharge={noCharge}
        tabSelected={tabSelected}
        handleModal={(bool) => {
          if (bool) {
            SaveOrder(tabSelected, 'saveO')
          } else {
            setConfirmDialog(false)
          }
        }}
      />
    </Grid>
  )
}

export default CardDetails
